// extracted by mini-css-extract-plugin
module.exports = {"tagGroupItemList":"TagGroupItemList_tagGroupItemList__2l0Ng","tagGroupItem":"TagGroupItemList_tagGroupItem__1wIdV"};